<div
  class="overlay"
  *ngIf="recommendations && !promotionItemsSettings?.Enabled"
>
  <div class="popup">
    <!-- If Continue to checkout button should be on top -->
    <div class="popup-footer" *ngIf="continueBtnOnTop">
      <button
        class="w-100 recipePopButton"
        type="button"
        (click)="openUrl('checkout')"
        [ngStyle]="{
          'background-color': SelectedButtonColor,
          color: SelectedButtonTextColor
        }"
      >
        <h2 class="m-0" [ngStyle]="{ color: SelectedButtonTextColor }">
          {{ recomendationsButtonText || "No Thanks , Continue to checkout" }}
        </h2>
      </button>
    </div>
    <div
      class="popup-header"
      [ngStyle]="{ 'background-color': SelectedButtonColor }"
      *ngIf="!continueBtnOnTop"
    >
      <h2 class="modalHeading" [ngStyle]="{ color: SelectedButtonTextColor }">
        Would you like to add
      </h2>
      <button
        type="button"
        [ngStyle]="{ color: SelectedButtonTextColor }"
        class="close fs-4"
        (click)="recommendations = false"
      >
        &times;
      </button>
    </div>
    <div class="popup-body p-2">
      <app-recipe [recipes]="recomendedRecipies"></app-recipe>

      <app-responsive-grid-style
        [products]="recomendedProducts"
      ></app-responsive-grid-style>
    </div>
    <div class="popup-footer" *ngIf="!continueBtnOnTop">
      <button
        class="w-100 recipePopButton"
        type="button"
        (click)="openUrl('checkout')"
        [ngStyle]="{
          'background-color': SelectedButtonColor,
          color: SelectedButtonTextColor
        }"
      >
        <h2 class="m-0" [ngStyle]="{ color: SelectedButtonTextColor }">
          {{ recomendationsButtonText || "No Thanks , Continue to checkout" }}
        </h2>
      </button>
    </div>
  </div>
</div>

<div class="overlay" *ngIf="recommendations && promotionItemsSettings?.Enabled">
  <div class="popup">
    <div class="popup-footer" *ngIf="continueBtnOnTop">
      <button
        class="w-100 recipePopButton"
        type="button"
        (click)="openUrl('checkout')"
        [ngStyle]="{
          'background-color': SelectedButtonColor,
          color: SelectedButtonTextColor
        }"
      >
        <h2 class="m-0" [ngStyle]="{ color: SelectedButtonTextColor }">
          {{ recomendationsButtonText || "No Thanks , Continue to checkout" }}
        </h2>
      </button>
    </div>

    <div
      class="popup-header"
      [ngStyle]="{ 'background-color': SelectedButtonColor }"
      *ngIf="!continueBtnOnTop"
    >
      <h2 class="modalHeading" [ngStyle]="{ color: SelectedButtonTextColor }">
        {{
          promotionItemsSettings?.Enabled && freeRecipies.length
            ? "Choose your free dish"
            : " Would you like to add"
        }}
      </h2>
      <button
        type="button"
        [ngStyle]="{ color: SelectedButtonTextColor }"
        class="close fs-4"
        (click)="recommendations = false"
      >
        &times;
      </button>
    </div>
    <div class="popup-body p-2">
      <ng-container
        *ngIf="freeRecipies.length && promotionItemsSettings?.Enabled"
      >
        <p class="m-0 fw-bolder">Choose your free side</p>
        <p class="mb-2 text-muted">
          You've unlocked free items. Make your selection
        </p>
        <ng-container *ngIf="!newDesign">
          <app-recipe
            [recipes]="freeRecipies"
            [isPromotedItem]="true"
            [showImage]="false"
          ></app-recipe>
        </ng-container>
        <ng-container *ngIf="newDesign">
          <app-new-recipe-card
            [recipes]="freeRecipies"
            [isPromotedItem]="true"
            card="main"
          >
          </app-new-recipe-card>
        </ng-container>
      </ng-container>

      <div
        class="position-relative mb-5 mt-5"
        *ngIf="
          recomendedRecipies.length &&
          freeRecipies.length &&
          promotionItemsSettings?.Enabled
        "
      >
        <hr />
        <p
          class="text-center fw-light bg-white position-absolute Add__More__Text text-muted"
        >
          Add more to your order
        </p>
      </div>

      <ng-container *ngIf="!newDesign">
        <app-recipe
          [recipes]="recomendedRecipies"
          [isPromotedItem]="false"
          [showImage]="false"
        ></app-recipe>
      </ng-container>
      <ng-container *ngIf="newDesign">
        <app-new-recipe-card
          [recipes]="recomendedRecipies"
          [isPromotedItem]="false"
          card="main"
        >
        </app-new-recipe-card>
      </ng-container>

      <app-responsive-grid-style
        [products]="recomendedProducts"
      ></app-responsive-grid-style>
    </div>
    <div class="popup-footer" *ngIf="!continueBtnOnTop">
      <button
        class="w-100 recipePopButton"
        type="button"
        (click)="openUrl('checkout')"
        [ngStyle]="{
          'background-color': SelectedButtonColor,
          color: SelectedButtonTextColor
        }"
      >
        <h2 class="m-0" [ngStyle]="{ color: SelectedButtonTextColor }">
          {{ recomendationsButtonText || "No Thanks , Continue to checkout" }}
        </h2>
      </button>
    </div>
  </div>
</div>

<div class="overlay" *ngIf="ShowCheckOutOffMsg">
  <div class="popup">
    <div
      class="popup-header"
      [ngStyle]="{ 'background-color': SelectedButtonColor }"
    >
      <h2 class="modalHeading" [ngStyle]="{ color: SelectedButtonTextColor }">
        Sorry for the inconvenience
      </h2>
      <button
        type="button"
        [ngStyle]="{ color: SelectedButtonTextColor }"
        class="close fs-4"
        (click)="ShowCheckOutOffMsg = ''"
      >
        &times;
      </button>
    </div>
    <div class="popup-body p-2">
      <h2 class="text-center">{{ ShowCheckOutOffMsg }}</h2>
    </div>
    <div class="popup-footer">
      <button
        class="w-100 recipePopButton"
        type="button"
        (click)="ShowCheckOutOffMsg = ''"
        [ngStyle]="{
          'background-color': SelectedButtonColor,
          color: SelectedButtonTextColor
        }"
      >
        <h2 class="m-0" [ngStyle]="{ color: SelectedButtonTextColor }">OKAY</h2>
      </button>
    </div>
  </div>
</div>
